import React from 'react';
import './PrivacyPolicy.css'; // 外部CSSファイルを適用

const PrivacyPolicy = () => {
  return (
    <div className="pb-container">
      <div className="pb-content">
        <h1 className="pb-title">プライバシーポリシー</h1>
        
        <section className="pb-section">
          <h2 className="pb-subtitle">1. 個人情報の収集について</h2>
          <p>
            当アプリケーションは、ユーザーの個人情報を収集する場合がありません
          </p>
        </section>

        <section className="pb-section">
          <h2 className="pb-subtitle">2. 個人情報の第三者提供</h2>
          <p>
            当アプリケーションは、法令に基づく場合を除き、収集した個人情報を第三者に提供することはありません。
          </p>
        </section>

        <section className="pb-section">
          <h2 className="pb-subtitle">3. 個人情報の管理</h2>
          <p>
            当アプリケーションは、収集した個人情報の漏洩、紛失、改ざん等を防ぐため、適切なセキュリティ対策を実施しています。
          </p>
        </section>

        <section className="pb-section">
          <h2 className="pb-subtitle">4. プライバシーポリシーの変更</h2>
          <p>
            本プライバシーポリシーの内容は、法令変更等の事情により、予告なく変更される場合があります。
          </p>
        </section>

        <section className="pb-section">
          <h2 className="pb-subtitle">5. お問い合わせ</h2>
          <p>
            本プライバシーポリシーに関するお問い合わせは、以下の連絡先までお願いいたします：
            y.msd0110@gmail.com
          </p>
        </section>

        <footer className="pb-footer">
          最終更新日：2024年2月17日
        </footer>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
